export default "__VITE_ASSET__7e9f18cc__"